import request from "@/utils/request";
import qs from 'qs'
import ds, { dsc, ___ } from '../utils/daoService/DaoServiceClientES6Adapter'

/* 海外欢迎 */
export function queryCreditInfo(data){
    return request({
        url: '/web/overseaOrder/queryCreditInfo',
        method: 'post',
        data
    })
}
export function queryCsCustInfo(data){
    return request({
        url: '/web/overseaOrder/queryCsCustInfo',
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify(data),
    })
}
/* 获取用户类型 */
 export function getUserType(data){
     return request({
         url: '/web/sysManage/getUserType',
         method: 'post',
         headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify(data),
     })
 }

/* DSR detail */
export function queryDSRDetail(data){
    return request({
        url: '/web/overseaOrder/queryDSRDetail',
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify(data),
    })
}
/* DSR查询 */
export function queryOverSeaAgentOrders(data){
    return request({
        url: '/web/overseaOrder/queryOverSeaAgentOrders',
        method: 'post',
        data
    })
}
/* 箱货信息查询 */
export function queryCtnCargoInfos(data){
    return request({
        url: '/web/overseaOrder/queryCtnCargoInfos',
        method: 'post',
        data
    })
}
/* 发票查询 */
export function queryInvoiceInfo(data){
    return request({
        url: '/web/overseaOrder/queryInvoiceInfo ',
        method: 'post',
        data
 /*        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify(data), */
    })
}
/* 发票详情 */
export function queryInvoiceDetailInfo(data){
    return request({
        url: '/web/overseaOrder/queryInvoiceDetailInfo ',
        method: 'post',
        data: qs.stringify(data),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
}
/* 分拨订单查询 */
export function queryForWebNew(data){
    return request({
        url: '/wms/ecustom/queryForWebNew',
       /*  url: 'http://180.168.59.38:9000/wms/queryForWebNew', */
        method: 'post',
        data
    })
}
/* 照片查看 */
export function getWmOrderAllPhotos(data){
    return request({
        url: '/wms/ecustom/getWmOrderAllPhotos',
       /*  url: 'http://180.168.59.38:9000/wms/queryForWebNew', */
        method: 'post',
        data
    })
}
/* 提货费用预估 */
export function predictFreight(data) {
    return request({
      url: '/cts-core/predictFreight',
      method: 'post',
      data,
    })
  }
  /* 图片下载 */
  export function download(url,data) {
    return request({
      url: url,
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9'
      },
      responseType: 'blob'
    })
  }
